import { useState } from 'react';

type UseModalArgType = {
  initialOpen?: boolean;
  closeModalLock?: boolean;
  onModalClose?: () => void;
  onModalOpen?: () => void;
};
const useModal = ({
  initialOpen,
  onModalOpen,
  onModalClose,
  closeModalLock,
}: UseModalArgType = {}) => {
  const [open, setOpen] = useState(!!initialOpen);
  const closeModal = () => {
    if (!closeModalLock) {
      setOpen(false);
      onModalClose?.();
    }
  };
  const openModal = () => {
    setOpen(true);
    onModalOpen?.();
  };

  const forceCloseModal = () => {
    setOpen(false);
    onModalClose?.();
  };

  return {
    openModal,
    closeModal,
    forceCloseModal,
    open,
  };
};
export default useModal;
